import router from "@/router";
import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';
import { LOGOUT } from "@/store/auth.module";
import store from '@/store'

export const Manager = (response, target = null) => {
    if (!response)
        return Message({ showClose: true, message: 'Oops, no se ha recibido información del error para ser procesado.', type: 'error'})
    
    let status = response.status
    let title = (status === 401) ? "Seguridad del Sistema" : `Error ${response.status} [${response.statusText}]`  
    let message = ''
    //let message = (status === 401) ? response.statusText : ((typeof response.data == 'string') ? response.data : response.data.message)
    //console.log(typeof response.data)
    //if(typeof response.data === 'object')
    //    console.log('es verdad')

    if(status === 401) {
        message = response.statusText
    } else if(typeof response.data == 'string'){
        message = response.data
    } if(typeof response.data === 'object'){
        if(response.data.hasOwnProperty('message'))
            message = response.data.message
        else if(response.data.hasOwnProperty('messages'))
            message = response.data.messages.error
        else
            message = 'Error desconocido.'
    }
    
    return MessageBox.alert(message, title, {
        type: 'warning',
        confirmButtonText: 'Entendido',
        dangerouslyUseHTMLString: true,
        callback: action => {
            if (status === 401) store.dispatch(LOGOUT).then(() => router.push({ name: "login" }))
        }
      })
}

export default { Manager }